<template lang="pug">
table-base.study-candidate-table
  //- ヘッダー部
  table-row-base.study-candidate-table__row-header.text-medium
    table-header-base.study-candidate-table__row-header__cell.align-left
      toggle-sort.study-candidate-table__row-header__cell__toggle(
        :sortSetting='sort.userName',
        @change-sort='sortChangeEvent($event, "userName")'
      )
        slot(name='userNameHeader')
    table-header-base.study-candidate-table__row-header__cell.align-left
      toggle-sort.study-candidate-table__row-header__cell__toggle(
        :sortSetting='sort.bcbtCode',
        @change-sort='sortChangeEvent($event, "bcbtCode")'
      )
        slot(name='bcbtCodeHeader')
    table-header-base.study-candidate-table__row-header__cell.align-left(v-if='isAdmin')
      toggle-sort.study-candidate-table__row-header__cell__toggle(
        :sortSetting='sort.academyName',
        @change-sort='sortChangeEvent($event, "academyName")'
      )
        slot(name='academyNameHeader')
    table-header-base.study-candidate-table__row-header__cell.align-left(v-if='isAdminOrAcademy')
      toggle-sort.study-candidate-table__row-header__cell__toggle(
        :sortSetting='sort.branchName',
        @change-sort='sortChangeEvent($event, "branchName")'
      )
        slot(name='branchNameHeader')
    table-header-base.study-candidate-table__row-header__cell.align-left
      toggle-sort.study-candidate-table__row-header__cell__toggle(
        :sortSetting='sort.gradeName',
        @change-sort='sortChangeEvent($event, "gradeName")'
      )
        slot(name='gradeNameHeader')
    table-header-base.study-candidate-table__row-header__cell.align-left
      toggle-sort.study-candidate-table__row-header__cell__toggle(
        :sortSetting='sort.statusName',
        @change-sort='sortChangeEvent($event, "statusName")'
      )
        slot(name='statusNameHeader')
    table-header-base.study-candidate-table__row-header__cell.align-center
      toggle-sort.study-candidate-table__row-header__cell__toggle(
        :sortSetting='sort.isPossible',
        @change-sort='sortChangeEvent($event, "isPossible")'
      )
        slot(name='possibilityHeader')
  template(v-for='studentData in studentDatas')
    //- 一覧表示部
    table-row-base.study-candidate-table__row.text-small.font-medium
      table-data-base.study-candidate-table__row__cell
        .study-candidate-table__row__cell__text {{ studentData.userName }}
      table-data-base.study-candidate-table__row__cell
        .study-candidate-table__row__cell__text {{ studentData.bcbtCode }}
      table-data-base.study-candidate-table__row__cell(v-if='isAdmin')
        .study-candidate-table__row__cell__text {{ studentData.academyName }}
      table-data-base.study-candidate-table__row__cell(v-if='isAdminOrAcademy')
        .study-candidate-table__row__cell__text {{ studentData.branchName }}
      table-data-base.study-candidate-table__row__cell
        .study-candidate-table__row__cell__text {{ studentData.gradeName }}
      table-data-base.study-candidate-table__row__cell
        .study-candidate-table__row__cell__text {{ studentData.statusName }}
      table-data-base.study-candidate-table__row__cell.align-center(:data-alert='studentData.isPossible')
        .study-candidate-table__row__cell__text.text-large.font-bold {{ possibilityCharacter(studentData.isPossible) }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TableBase from '@/components/atoms/TableBase.vue'
import TableRowBase from '@/components/atoms/TableRowBase.vue'
import TableHeaderBase from '@/components/atoms/TableHeaderBase.vue'
import TableDataBase from '@/components/atoms/TableDataBase.vue'
import ToggleSort from '@/components/molecules/manager/ToggleSort.vue'
import { StudentListType, StudentListSortType } from '@/models/studentListModel'
import { UserRoles } from '@/const/UserRoles'
import { CommonCharacterSetting } from '@/const/DisplaySettings'

/**
 * テスト受験可能なユーザーテーブル
 */
@Component({
  components: {
    TableBase,
    TableRowBase,
    TableHeaderBase,
    TableDataBase,
    ToggleSort,
  },
})
export default class StudyCandidateTable extends Vue {
  // ユーザ権限
  @Prop()
  userRole!: UserRoles

  // ソート値（項目毎の昇順フラグ）
  @Prop()
  sort!: StudentListSortType

  // ソート値変更時イベント
  @Prop()
  sortChangeEvent!: Function

  // 生徒一覧情報
  @Prop()
  studentDatas!: StudentListType[]

  // 可否文字列を表示
  private possibilityCharacter(isPossible: boolean) {
    return isPossible ? CommonCharacterSetting.POSSIBLE : CommonCharacterSetting.NOT_POSSIBLE
  }

  // システム管理者であるか
  private get isAdmin(): boolean {
    return this.userRole === UserRoles.ADMIN
  }

  // システム管理者または塾管理者であるか
  private get isAdminOrAcademy(): boolean {
    return this.userRole === UserRoles.ADMIN || this.userRole === UserRoles.ACADEMY
  }
}
</script>

<style lang="stylus" scoped>
.study-candidate-table
  width 100%

  &__row-header,
  &__row
    border-bottom 1px solid var(--color-manager-list__border)

  &__row-header
    background var(--color-manager-list__background)

    &__cell
      padding 10px 20px

      &:nth-last-child(2)
        width 215px
      &:nth-last-child(1)
        width 130px

  &__row
    background var(--color-manager-list__background)
    height 55px

    &__cell
      padding 0 20px

      &[data-alert='true'] &__text
        color var(--color-manager-list-alert__text)

    &:hover
      background var(--color-manager-list__hover)
</style>
